import * as React from 'react';
import ModuleWallpaperGroupsStore from '../_stores/ModuleWallpaperGroupsStore';
import { MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import { Trans } from 'react-i18next';
import ModuleDuplicateContainer from '../../_containers/ModuleDuplicateContainer';

export type Props = {
	moduleId?: string
	group?: number
	onGroupChange?: (e:React.ChangeEvent<{name?: string; value: unknown}>) => void
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleWallpaperGroupsSettings extends React.Component<Props> {
	stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	render = () => <>
		<FormControl onMouseDown={this.stopPropagation} variant="filled">
			<InputLabel id={this.props.moduleId+"-label"}><T>Group</T></InputLabel>
			<Select labelId={this.props.moduleId+"-label"} variant="filled" value={String(this.props.group)} onChange={this.props.onGroupChange}>
				<MenuItem value="17"><T>Half-Drop</T></MenuItem>
				<MenuItem value="18"><T>Half-Brick</T></MenuItem>
				<MenuItem value="19"><T>Dot Repeat</T></MenuItem>
				<MenuItem value="2"><T>Mirror Horizontal (pm)</T></MenuItem>
				<MenuItem value="20"><T>Mirror Vertical (pm)</T></MenuItem>
				<MenuItem value="5"><T>Mirror 4-way (pmm)</T></MenuItem>
				<MenuItem value="10"><T>Mirror 4-way angled (p4m)</T></MenuItem>
				<MenuItem value="16"><T>Mirror 6-way angled (p6m)</T></MenuItem>
			</Select>
		</FormControl>

		<div className="actions-wrapper">
			<ModuleDuplicateContainer moduleId={this.props.moduleId}/>
		</div>
	</>
}